import { render, staticRenderFns } from "./SelectorBuyers.vue?vue&type=template&id=6187efb0&"
import script from "./SelectorBuyers.vue?vue&type=script&lang=js&"
export * from "./SelectorBuyers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports